import { saas } from '../supabaseClient';

const getDeviceContext = () => {
  if (typeof window === 'undefined') return {};

  return {
    userAgent: window.navigator?.userAgent || '',
    language: window.navigator?.language || '',
    platform: window.navigator?.platform || '',
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || '',
    screen: {
      width: window.screen?.width || null,
      height: window.screen?.height || null,
    },
    restaurantName: window.localStorage?.getItem('currentRestaurantName') || '',
  };
};

export const logSecurityEvent = async ({
  eventType,
  actorType = 'unknown',
  actorId = null,
  actorName = '',
  outcome,
  reason = '',
  route,
  deviceContext = {},
}) => {
  const restaurantId = localStorage.getItem('currentRestaurantId');
  if (!restaurantId || !eventType || !outcome) return;

  try {
    const { error } = await saas('security_audit_logs').insert({
      event_type: eventType,
      actor_type: actorType,
      actor_id: actorId == null ? null : String(actorId),
      actor_name: actorName || null,
      outcome,
      reason: reason || null,
      route: route || window.location.pathname,
      device_context: {
        ...getDeviceContext(),
        ...deviceContext,
      },
    });

    if (error && error.code !== '42P01' && error.code !== '42501') {
      console.warn('Security audit log failed:', error.message);
    }
  } catch (err) {
    console.warn('Security audit log skipped:', err.message);
  }
};
